'use strict';
var util = require('../../util'),
	dialog = require('../../dialog'),
	tooltip = require('./tooltip'),
	bornModules = require('../../helpers/born.modules').default;

/**
 * Renders error in Coming Soon form
 * @param emailInput jQuery-object of verified field
 * @param text error message
 */
function showError(emailInput, text) {
	var id = emailInput.attr('id') + '-error';
	if ($('#' + id).length) {
		$('#' + id).html(text).show();
	} else {
		$('<span></span>', {
			'id': id,
			'class': 'error'
		}).html(text).insertAfter(emailInput);
	}
}

/**
 * Adds event handler on form submit 
 */
function initEvents() {
	notifyPopupEvents();
}

function notifyPopupEvents() {
	var pdpMain = $('.pdp');

	pdpMain.off('click', '#coming-soon-product').on('click', '#coming-soon-product', function (e) {
		e.preventDefault();

		
		var source = $(this).data('source');

		if (source && source === 'quickview') {
			showComingSoonSection.call(this);
		} else {
			openComingSoonPopup.call(this);
		}
	});

}

function showComingSoonSection() {
	var pdpForm = $(this).closest('.pdpForm'),
		csForm = pdpForm.find('.js-comingsoon-form');

	// If already shown
	if (csForm && csForm.length >= 1) {
		return;
	}

	$.ajax({
		url: Urls.comingSoonForm,
		data: pdpForm.serialize(),
		success: function (response) {
			pdpForm.append(response);
			pdpForm.data('source', $('#source').val());
			initPopupFormEvents();
		}
	});
}

function openComingSoonPopup() {
	var token = $(this).parent().find('.js-csrf-token'),
		pid = $(this).parents().find('.js-pid');
		
	var notifyUrl = util.appendParamsToUrl(Urls.comingSoonPopup, {
		'csrf_token': token.val(),
		'pid': pid.val(),
		'source': 'comingsoon'
	});

	dialog.open({
		url: notifyUrl,
		options: {
			width: 400,
			update: true
		},
		afterCreateCallback: openNotifyPopupCallback
	});
}

function initPopupFormEvents() {
	scrollToEmail();
	$('.js-notify-button').click(function (e) {
		e.preventDefault();
		var fieldset = $(this).closest('.js-comingsoon-form');
		var emailInput = fieldset.find('[name$=email]');
		var data = fieldset.serialize();
		var btn = fieldset.find("button[type=submit]");
		$.ajax({
			url: Urls.comingSoonSubmit,
			method: 'POST',
			data: data + '&' + btn.attr('name'),
			dataType: 'json',
			success: function (data) {
				if (!data.validationError) {
					// Remove errors if any
					emailInput.parent().find('span.error').remove();

					// Show confirmation
					fieldset.html(data.message);

					var source = $('.js-open-notifypopup').closest('.pdpForm').data('source');

					if (source === 'cart') {
						fieldset.find('.js-cs-continue').remove();
					}
					$('.coming-soon__description').hide();

				} else {
					showError(emailInput, data.message);
				}

			},
			error: function () {
				showError(emailInput, 'error');
			}
		});
	});

	// Continue shopping button handler
	$('.js-comingsoon-form').on('click', '.js-cs-continue', function (e) {
		e.preventDefault();
		dialog.close();
	});
}

function scrollToEmail() {
		setTimeout(function () {
		    var wrapEl = $('.js-comingsoon-form');
			var emailField = wrapEl.find('input[name$="_email"]');
			$('.window-overlay').animate({
				scrollTop: emailField.offset().top
			}, 500);

			wrapEl.find('input[name$="_email"]').on('focus', function(){
				var _this = $(this);
				setTimeout(function() {
					$('.overlay--active').scrollTop( $('.window-overlay--modal').height() );
				}, 500);
			});
		}, 500);
}

/**
 * Callback which is triggered on popup init event
 */
function openNotifyPopupCallback() {
	bornModules.carousel.init();
	bornModules.video.init();
	bornModules.modalToggle.init();
	bornModules.toggle.init();
	initPopupFormEvents();
}

module.exports.init = initEvents;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/comingsoon.js